import _ from 'lodash';
import moment from 'moment';
// eslint-disable-next-line
import dataStorage from '../misc/data-storage';

function castToLong(value) {
  return Number.isInteger(value) ? value : parseInt(value, 10);
}

function castToDouble(value) {
  const isNumber = Number(value) === value;
  return isNumber ? value : parseFloat(value);
}

export default class RemoteObject {
  constructor(retObject) {
    this.retObject = retObject;
  }

  isEmpty() {
    return !this.retObject || _.isEmpty(this.retObject);
  }

  getRetObject() {
    return this.retObject;
  }

  getId() {
    return this.getLong('id');
  }

  getClassName() {
    return this.getString('className');
  }

  getObject(name) {
    return this.retObject[name] !== undefined ? this.retObject[name] : null;
  }

  /**
   * Use this method *only* if it is really really necessary. It is very
   * rare that we need to modify an existing RemoteObject instance.
   */
  setObject(name, value) {
    if (value instanceof RemoteObject) {
      this.retObject[name] = value.retObject;
    } else {
      this.retObject[name] = value;
    }
  }

  getRemoteObject(name) {
    const value = this.getObject(name);
    return value !== null ? new RemoteObject(value) : null;
  }

  getRemoteObjects(name) {
    const value = this.getObject(name);
    return Array.isArray(value) ? value.map(el => (el ? new RemoteObject(el) : null)) : null;
  }

  getString(name) {
    return this.getObject(name);
  }

  getStrings(name) {
    return this.getObject(name);
  }

  getLocalizeString(name) {
    let localizeName = name;
    switch (dataStorage.getLanguage()) {
      case 'en_US':
        localizeName = `${name}En`;
        break;
      case 'zh_CN':
        localizeName = `${name}Cn`;
        break;
      case 'zh_TW':
        localizeName = `${name}Tw`;
        break;
      default:
        localizeName = `${name}En`;
        break;
    }
    return this.getObject(localizeName);
  }

  getLong(name) {
    const value = this.getObject(name);
    return value !== null ? castToLong(value) : null;
  }

  getLongOrZero(name) {
    const value = this.getLong(name);
    return value !== null ? value : 0;
  }

  getLongAsString(name) {
    const value = this.getLong(name);
    return value !== null ? value.toString() : null;
  }

  getLongs(name) {
    const value = this.getObject(name);
    return Array.isArray(value) ? value.map(el => castToLong(el)) : null;
  }

  getDouble(name) {
    const value = this.getObject(name);
    return value !== null ? castToDouble(value) : null;
  }

  getBoolean(name) {
    const value = this.getObject(name);
    if (value !== null) {
      return (value === true || value === 'true' || value === 1 || value === '1');
    } else {
      return null;
    }
  }

  getBooleanOrFalse(name) {
    const value = this.getBoolean(name);
    return value !== null ? value : false;
  }

  is(name) {
    return this.getBooleanOrFalse(name);
  }

  isNot(name) {
    return !this.is(name);
  }

  getMoment(name) {
    const value = this.getLong(name);
    return value !== null ? moment(value) : null;
  }
}
